import useInfiniteFetch from '@hooks/useInfiniteFetch';
import { getHost } from '@utils/api-helper/host';
import { unstable_serialize } from 'swr/infinite';

const defaultHost = getHost();

const useCombats = (
  goalUID,
  preference,
  state,
  options = { fallbackData: undefined, revalidateOnMount: false }
) => {
  const key = `${defaultHost}v1/uplus/contest/all/?goal_uid=${goalUID}&preference=${preference}&state=${state}&limit=10&offset=0`;

  const {
    data: combatsData,
    isValidating,
    ...rest
  } = useInfiniteFetch(
    key,
    { applyOffsetsAutomatically: false },
    {
      fallbackData: options.fallbackData ? [options.fallbackData] : undefined,
      revalidateOnMount: options.revalidateOnMount,
      revalidateFirstPage: false
    }
  );

  return {
    combatsData,
    isValidating,
    ...rest,
    key: unstable_serialize(() => key)
  };
};

export default useCombats;
